import React from 'react'
import Content from '../Content'
import { Link } from 'gatsby'
import SharePost from '../../components/Share/SharePost'
import Disqus from '../Disqus'


const ArticleTemplate = ({
  content,
  contentComponent,
  cover,
  meta_title,
  meta_desc,
  tags,
  title,
  date,
  author,
  slug,
  excerpt
}) => {
  const PostContent = contentComponent || Content
  return (
    <div className='container post-container'>
      <h1 className='post-detail__title'>
        {title}
      </h1>
      <div className="post-detail__info">
        <small>{date} by {author}</small>
      </div>
      {cover && <img src={cover} alt={title} />}
      <PostContent className='post-detail__content' content={content} />
      <div className='post-detail__tags' style={{ marginTop: `4rem` }}>
        {(tags && tags.length)
          ? tags.map(tag => (
            <Link className='post-detail__tags__tag' key={tag + `tag`} to='/'>{tag}</Link>
          ))
          : null}
      </div>
      <SharePost
        title={title}
        slug={slug}
        excerpt={excerpt}
      />

      <hr />
      <Disqus
        title={title}
        slug={slug}
      />

    </div>
  )
}

export default ArticleTemplate
